// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__ajevi","Highlight":"Button__Highlight__1dpEh","Enlarge":"Button__Enlarge__158Kp","BorderLeft":"Button__BorderLeft__2WNYs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 148
// module chunks = 0